export default __webpack_public_path__ + "static/wiz-80051482ace3804ffe77ac44cf16a768.png";